import React from "react";
import { Paper } from "@mui/material";
import Table from "@mostrans/web-components/components/base/Table";
import ChartPapikostik from "./ChartPapikostik/ChartPapikostik";
import ModalPdfPapikostik from "./modals/ModalPdfPapikostik";

function PapikostikResult(props) {
  const { dataCandidateByID } = props;

  const dimensionOrders = [
    "Work Direction",
    "Workstyle",
    "Activity",
    "Followership",
    "Leadership",
    "Social Nature",
    "Temperament",
  ];

  const dimensionOrder = {
    "Work Direction": ["A", "N", "G"],
    "Workstyle": ["C", "D", "R"],
    "Activity": ["T", "V"],
    "Followership": ["W", "F"],
    "Leadership": ["L", "P", "I"],
    "Social Nature": ["S", "B", "O", "X"],
    "Temperament": ["E", "K", "Z"],
  };

  const dimensionsData = dataCandidateByID?.Papikostik
    ? dataCandidateByID.Papikostik.reduce((acc, item) => {
        const dimension = getDimension(item.code); // Utility function to get dimension by code
        if (!acc[dimension]) {
          acc[dimension] = [];
        }
        acc[dimension].push(item);
        return acc;
      }, {})
    : null;

  function getDimension(code) {
    switch (code) {
      case "A":
      case "N":
      case "G":
        return "Work Direction";
      case "L":
      case "P":
      case "I":
        return "Leadership";
      case "T":
      case "V":
        return "Activity";
      case "S":
      case "B":
      case "O":
      case "X":
        return "Social Nature";
      case "C":
      case "D":
      case "R":
        return "Workstyle";
      case "E":
      case "K":
      case "Z":
        return "Temperament";
      case "W":
      case "F":
        return "Followership";
      default:
        return "Other";
    }
  }

  console.log("DIMENSION DATA", dimensionsData);

  return dimensionsData ? (
    <React.Fragment>
      <div className="form-row">
        <div
          className="col-md-12"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ModalPdfPapikostik dataCandidateByID={dataCandidateByID} />
        </div>
      </div>
      <div className="form-row mt-2">
        <div
          className="col-md-12"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ChartPapikostik dataCandidateByID={dataCandidateByID} />
        </div>
      </div>
      <div className="form-row mt-2">
        <div className="col-md-12">
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Table>
              <thead>
                <tr>
                  <th>Dimensions</th>
                  <th>Aspects</th>
                  <th>Score</th>
                  <th>Interpretation</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(dimensionsData)
                  // Sort the dimensions based on the pre-defined order in 'dimensionOrder'
                  .sort(([a], [b]) => {
                    const orderA = dimensionOrders.indexOf(a);
                    const orderB = dimensionOrders.indexOf(b);
                    return orderA - orderB;
                  })
                  // Render the items for each dimension
                  .map(([dimension, items]) => {
                    // Sort the items within each dimension if needed (optional)
                    const orderedItems = items.sort((a, b) => {
                      const order = dimensionOrder[dimension];
                      if (!order) return 0; // If no specific order, leave unsorted
                      return order.indexOf(a.code) - order.indexOf(b.code);
                    });

                    return orderedItems.map((item, index) => (
                      <tr
                        key={item.id} // Use item.id for uniqueness
                        style={{
                          backgroundColor: "transparent",
                        }}
                      >
                        {index === 0 && (
                          <td rowSpan={orderedItems.length}>{dimension}</td>
                        )}
                        <td>
                          ({item.code}) {item.aspect}
                        </td>
                        <td>{item.score}</td>
                        <td>{item.interpretation}</td>
                      </tr>
                    ));
                  })}
              </tbody>
            </Table>
          </Paper>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className="form-row mt-2">
        <div className="col-md-12">Hasil Papikostik Belum Tersedia</div>
      </div>
    </React.Fragment>
  );
}

export default PapikostikResult;
